import { useState, useEffect } from "react";
import "./style.css"
import API from '../../utils/API';
import Swal from 'sweetalert2';
import Loader from "../Loader";

function CostValueG(props) {
    const [edit, setEdit] = useState(false)
    const [gValue, setGValue] = useState({
        "model_id": props.modelId,
        "start_date": "",
        "base_rate": "",
        "consumption_rate": "",
        "carbon_charge": "",
        "municipal_tax": "",
        "ps_tax": "",
        "gs_tax": ""
    })
    const [acceptable, setAcceptable] = useState(false)
    // const [error, setError] = useState(null)
    const [loading, setLoading] = useState(null)

    useEffect(() => {
        if (!props.value) return
        setGValue(props.value)
    }, [props])

    const updateValue = (e) => {
        const { name, value } = e.target;
        setGValue(prevValue => {
            return {
                ...prevValue,
                [name]: value.trim()
            }
        })
    }

    useEffect(() => {
        let mandatory = ['start_date', 'base_rate', 'consumption_rate',
            'carbon_charge', 'municipal_tax', 'ps_tax', 'gs_tax'
        ]

        for (let item of mandatory) {
            if (gValue[item] !== '') continue
            setAcceptable(false)
            return
        }
        setAcceptable(true)

    }, [gValue])

    const postValue = async (e) => {

        let tempValue = { ...gValue }
        const toFormat = ['base_rate', 'consumption_rate', 'carbon_charge',
            'municipal_tax', 'ps_tax', 'gs_tax'
        ]

        for (let item of toFormat) {
            tempValue[item] = tempValue[item] ? parseFloat(tempValue[item]).toFixed(6) : tempValue[item]
        }
        setLoading(true)
        const cancelToken = API.cancelToken();
        
        try {
            if (props.edit) {
                await API.postValueG(cancelToken, tempValue)
            } else if (edit) {
                const toDel = ['model_id', 'value_id', 'created_at', 'updated_at']
                const id = tempValue['value_id']
                for (let del of toDel) {
                    delete tempValue[del];
                }
                await API.putValueG(cancelToken, id, tempValue)
            }
            if (props.edit) props.open(false)
            setEdit(false)
            props.setUpdate(!props.update)
        } catch (err) {
            console.log(err)
            if (err.message === 'cancelling') return
            if (err.response && err.response.data) {
                try {
                    if ('general' in err.response.data || 'message' in err.response.data) {
                        Swal.fire({
                            title: 'Error.',
                            text: err.response.data.general,
                            icon: 'warning',
                            confirmButtonText: 'Ok',
                            confirmButtonColor: '#007b4e',
                        });
                    }
                } catch (e) {
                    Swal.fire({
                        title: 'Error.',
                        text: err.response.data,
                        icon: 'warning',
                        confirmButtonText: 'Ok',
                        confirmButtonColor: '#007b4e',
                    });
                }
            } else {
                Swal.fire({
                    title: 'Error.',
                    text: 'An error occurred, please try again later.',
                    icon: 'warning',
                    confirmButtonText: 'Ok',
                    confirmButtonColor: '#007b4e',
                });
            }
        } finally {
            setLoading(false)
        }
    }

    return (
        <div className="flex flex-row item-center justify-between input-border p-4">
            <div className='w-full flex flex-wrap'>
                <div className='tablet:w-2/12 mobile:w-full'>
                    <div className='tablet:w-2/12 mobile:w-full min-w-[100px] mb-4'>
                        <p className='text-xs mb-1'>Start Date</p>
                        <input
                            type="date"
                            name="start_date"
                            className='text-xs input-color outline-none w-full hide-input-background p-1'
                            defaultValue={gValue.start_date !== "" ? gValue.start_date.split('T')[0] : ""}
                            onChange={updateValue} />
                    </div>
                </div>
                <div className='tablet:w-2/12 mobile:w-full'>
                    <div className='tablet:w-2/12 mobile:w-full min-w-[100px] mb-4'>
                        <p className='text-xs mb-1'>Consumption</p>
                        <div className='flex flex-nowrap items-center'>
                            <span className='mr-1'>$</span>
                            <input
                                placeholder='Price'
                                className='hide-input-background text-sm input-color outline-none w-full p-1'
                                type="number"
                                step="0.1"
                                disabled={!props.edit && !edit}
                                name="consumption_rate"
                                defaultValue={gValue.consumption_rate !== "" ? gValue.consumption_rate : ""}
                                onChange={updateValue} />
                        </div>
                    </div>
                    <div className='tablet:w-2/12 mobile:w-full min-w-[100px] mb-4'>
                        <p className='text-xs mb-1'>Base Rate</p>
                        <div className='flex flex-nowrap items-center'>
                            <span className='mr-1'>$</span>
                            <input
                                placeholder='Price'
                                className='hide-input-background text-sm input-color outline-none w-full p-1'
                                type="number"
                                step="0.1"
                                disabled={!props.edit && !edit}
                                name="base_rate"
                                defaultValue={gValue.base_rate !== "" ? gValue.base_rate : ""}
                                onChange={updateValue} />
                        </div>
                    </div>
                </div>
                <div className='tablet:w-2/12 mobile:w-full'>
                    <div className='tablet:w-2/12 mobile:w-full min-w-[100px] mb-4'>
                        <p className='text-xs mb-1'>Carbon Charge</p>
                        <div className='flex flex-nowrap items-center'>
                            <span className='mr-1'>$</span>
                            <input
                                placeholder='Price'
                                className='hide-input-background text-sm input-color outline-none w-full p-1'
                                type="number"
                                step="0.1"
                                disabled={!props.edit && !edit}
                                name="carbon_charge"
                                defaultValue={gValue.carbon_charge !== "" ? gValue.carbon_charge : ""}
                                onChange={updateValue} />
                        </div>
                    </div>
                    <div className='tablet:w-2/12 mobile:w-full min-w-[100px] mb-4'>
                        <p className='text-xs mb-1'>Municipal Tax</p>
                        <div className='flex flex-nowrap items-center'>
                            <input
                                placeholder='Percent'
                                className='hide-input-background text-sm input-color outline-none w-full p-1'
                                type="number"
                                step="0.1"
                                disabled={!props.edit && !edit}
                                name="municipal_tax"
                                defaultValue={gValue.municipal_tax !== "" ? gValue.municipal_tax : ""}
                                onChange={updateValue} />
                            <span className='ml-1'>%</span>
                        </div>
                    </div>
                </div>
                <div className='tablet:w-2/12 mobile:w-full'>
                    <div className='tablet:w-2/12 mobile:w-full min-w-[100px] mb-4'>
                        <p className='text-xs mb-1'>PST</p>
                        <div className='flex flex-nowrap items-center'>
                            <input
                                placeholder='Percent'
                                className='hide-input-background text-sm input-color outline-none w-full p-1'
                                type="number"
                                step="0.1"
                                disabled={!props.edit && !edit}
                                name="ps_tax"
                                defaultValue={gValue.ps_tax !== "" ? gValue.ps_tax : ""}
                                onChange={updateValue} />
                            <span className='ml-1'>%</span>
                        </div>
                    </div>
                    <div className='tablet:w-2/12 mobile:w-full min-w-[100px] mb-4'>
                        <p className='text-xs mb-1'>GST</p>
                        <div className='flex flex-nowrap items-center'>
                            <input
                                placeholder='Percent'
                                className='hide-input-background text-sm input-color outline-none w-full p-1'
                                type="number"
                                step="0.1"
                                disabled={!props.edit && !edit}
                                name="gs_tax"
                                defaultValue={gValue.gs_tax !== "" ? gValue.gs_tax : ""}
                                onChange={updateValue} />
                            <span className='ml-1'>%</span>
                        </div>
                    </div>
                </div>
            </div>
            <div className='tablet:w-3/12 mobile:w-full'>
                <div className='flex flex-nowrap items-center justify-end h-full'>
                    {
                        edit && !loading &&
                        <div className='mr-8 border-light-green block text-sm text-green4 font-medium cursor-pointer' onClick={() => setEdit(false)}>
                            Cancel
                        </div>
                    }
                    {
                        (props.edit || edit) && acceptable && !loading &&
                        <button className='submit-button-small' onClick={postValue}>
                            Save
                        </button>
                    }
                    {
                        (!props.edit && !edit) && acceptable && !loading &&
                        <button className='submit-button-small' onClick={() => setEdit(true)}>
                            Edit
                        </button>
                    }
                    {
                        (props.edit || edit) && loading &&
                        <Loader />
                    }
                </div>
            </div>
        </div>
    )
}

export default CostValueG;
